import { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const total = TESTIMONIALS.length;

  const prev = () => setIdx((i) => (i - 1 + total) % total);
  const next = () => setIdx((i) => (i + 1) % total);

  const current = TESTIMONIALS[idx];

  return (
    <section id="recensioni" data-testid="testimonials-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 reveal">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
              <span className="w-8 h-px bg-brand-primary" />
              Le voci dei clienti
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-ink mt-4 text-balance">
              Non sono solo recensioni.<br />
              <span className="text-brand-primary">Sono promesse mantenute.</span>
            </h2>
            <div className="flex items-center gap-1 mt-6">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-brand-primary text-brand-primary" />
              ))}
              <span className="ml-2 font-semibold text-brand-ink">4.9 / 5</span>
              <span className="text-brand-body text-sm ml-2">su oltre 300 recensioni</span>
            </div>
          </div>

          <div className="lg:col-span-7 reveal reveal-delay-1">
            <div
              data-testid="testimonial-card"
              className="relative bg-brand-surface border border-brand-line rounded-2xl p-8 lg:p-12"
            >
              <Quote className="absolute top-6 right-6 w-14 h-14 text-brand-muted/50" strokeWidth={1.2} />
              <p className="font-display text-2xl lg:text-3xl leading-snug text-brand-ink tracking-tight max-w-2xl">
                "{current.text}"
              </p>

              <div className="mt-8 flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-brand-primary text-white flex items-center justify-center font-display font-bold text-lg">
                    {current.name
                      .split(" ")
                      .filter((p) => !p.endsWith("."))
                      .map((p) => p[0])
                      .slice(0, 2)
                      .join("")}
                  </div>
                  <div>
                    <div className="font-bold text-brand-ink">{current.name}</div>
                    <div className="text-sm text-brand-body">{current.role}</div>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <button
                    onClick={prev}
                    aria-label="Recensione precedente"
                    data-testid="testimonial-prev-btn"
                    className="w-11 h-11 rounded-full border border-brand-line bg-white hover:bg-brand-primary hover:text-white hover:border-brand-primary text-brand-ink flex items-center justify-center transition-all"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <button
                    onClick={next}
                    aria-label="Recensione successiva"
                    data-testid="testimonial-next-btn"
                    className="w-11 h-11 rounded-full border border-brand-line bg-white hover:bg-brand-primary hover:text-white hover:border-brand-primary text-brand-ink flex items-center justify-center transition-all"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              </div>

              {/* dots */}
              <div className="flex items-center gap-1.5 mt-6">
                {TESTIMONIALS.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    data-testid={`testimonial-dot-${i}`}
                    aria-label={`Vai alla recensione ${i + 1}`}
                    className={`h-1.5 rounded-full transition-all ${
                      i === idx ? "w-8 bg-brand-primary" : "w-2 bg-brand-muted"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
